import { AnimatePresence, motion } from 'framer-motion';
import { Suspense } from 'react';
import { lazily } from 'react-lazily';
import { Outlet, ScrollRestoration } from 'react-router-dom';

import { useCurrentCompany, useCurrentUser } from '@bonusly/who-am-i';

const { Welcome } = lazily(() => import('../../modules/onboarding'));

const transition = {
	duration: 0.4,
	ease: [0.68, -0.3, 0.265, 1.25] as const,
};

export const RootLayout = () => {
	const company = useCurrentCompany();
	const user = useCurrentUser();

	const isSuperAdmin = user?.super_admin;
	const needsSignupCompletion = company?.sign_up?.state === 'company_info';

	return (
		<>
			<ScrollRestoration />
			<AnimatePresence mode="wait">
				{needsSignupCompletion && !isSuperAdmin ? (
					<motion.div key="welcome" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={transition}>
						<Suspense>
							<Welcome />
						</Suspense>
					</motion.div>
				) : (
					<motion.div key="outlet" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={transition}>
						<Outlet />
					</motion.div>
				)}
			</AnimatePresence>
		</>
	);
};
